// Spec 078 FR-030 — detecção de WebGL ANTES de montar o chunk 3D. Sem contexto ⇒ o chunk
// nunca é baixado e a tela cai no 2D (ou no painel textual, na rota ambiente). Uma sondagem por
// sessão: criar contextos WebGL é caro e alguns navegadores limitam a quantidade viva.
import * as React from "react";

let cached: boolean | null = null;

export function detectWebGL(): boolean {
  if (cached !== null) return cached;
  try {
    if (typeof document === "undefined") return (cached = false);
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl2") ??
      canvas.getContext("webgl") ??
      canvas.getContext("experimental-webgl");
    cached = gl !== null && gl !== undefined;
    // Libera o contexto de sondagem (o navegador tem um teto de contextos vivos).
    const lose = (
      gl as { getExtension?: (n: string) => { loseContext?: () => void } | null } | null
    )?.getExtension?.("WEBGL_lose_context");
    lose?.loseContext?.();
  } catch {
    cached = false;
  }
  return cached;
}

/** Só para testes: força nova sondagem. */
export function resetWebGLSupportCache(): void {
  cached = null;
}

export function useWebGLSupport(): boolean {
  const [supported] = React.useState<boolean>(() => detectWebGL());
  return supported;
}
